import { Record } from 'immutable';
import _ from 'lodash';

import { CurrencyCode } from 'utils/currencyFormat';

import Deed from '../deed/model';

const properties = {
  id: null,
  deed: null,
  user: {},
  creditAmount: 0,
  currencyCode: 'USD',
  createdAt: null,
  publishedAt: null,
  expiryDate: null,
  note: null,
  transactionType: null,
};

export default class WalletTransaction extends Record(properties, 'WalletTransaction') {
  public readonly id!: string;

  public readonly deed?: Deed;

  public readonly user!: { id: string };

  public readonly creditAmount!: number;

  public readonly currencyCode!: CurrencyCode;

  public readonly createdAt!: Date;

  public readonly publishedAt!: Date;

  public readonly expiryDate?: Date | null;

  public readonly note!: string;

  public readonly transactionType!: string;

  constructor(values: any = {}) {
    const validValues = _.pick(values, Object.keys(properties));
    super({
      ...validValues,
      user: { id: values.user._id },
      deed: values.deed && new Deed(values.deed),
    });
  }
}
